module.exports = __webpack_public_path__ + "static/media/grin-beam-sweat.405e0377.svg";